import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../../i18';
import { showErrorMessage, showPromiseNotification } from '../../common/notification';
import ShareAppModal from '../../modals/shareAppModal/shareAppModal';
import Globals from '../../common/utils';
import { onOffNotification } from '../../slices/authSlice';

const Profile = () => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const userInfo = useSelector((state) => state.auth.userInfo);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const shareUrl = Globals.APP_BASE_URL;
    const title = t("checkoutTheApp");

    const handleCopyLink = () => {
        navigator.clipboard
            .writeText(shareUrl)
            .then(() => {
                setIsModalOpen(true);
            })
            .catch(() => {
                showErrorMessage(t("linkCopyFailed"));
            });
    };

    const handleNotificationChange = useCallback((e) => {
        const myPromise = new Promise((resolve, reject) => {
            dispatch(
                onOffNotification({
                    payload: {
                        is_notify: e.target.checked,
                    },
                })
            )
                .then(async (response) => {
                    if (response.payload.code == 200) {
                        resolve(response.payload);
                    }
                    else {
                        reject(response.payload)
                    }
                });
        });

        showPromiseNotification(myPromise);
    }, []);

    return (
        <>
            <div className="course-single-area pd-top-120 pd-bottom-90 bgBrown">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="PageTitleBox pb-0">
                                <h2 className="PageTitleHeading">{t('profileHeading')}</h2>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="ProfileMainBox">
                                <div className="EditProfileImgBox">
                                    <img
                                        src={userInfo?.image || process.env.PUBLIC_URL + "/assets/img/icon/default.jpg"}
                                        alt="EditProfileImg"
                                        id="EditProfileImg"
                                        className="EditProfileImg img-cover"
                                    />
                                    <Link to="/edit-profile" className="EditProfileInputBox">
                                        <img
                                            src={process.env.PUBLIC_URL + "/assets/img/icon/EditinputImg.svg"}
                                            alt="EditinputImg"
                                            className="EditinputImg img-cover"
                                        />
                                    </Link>
                                </div>
                                {/* <div className="ProgresBarmain">
                                    <div
                                        className="progress"
                                        role="progressbar"
                                        aria-label="Basic example"
                                        aria-valuenow={25}
                                        aria-valuemin={0}
                                        aria-valuemax={100}
                                    >
                                        <div className="progress-bar" style={{ width: "50%" }} />
                                        <span className="ProgressText">50%</span>
                                    </div>
                                </div> */}
                                <div className="ProFileOtherPageMain">
                                    <div className="row">
                                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                            <div className="ProfileOtherPageBox">
                                                <div className="ProfileOtherPageBoxcard">
                                                    <Link to="/edit-profile" className="ProfileOtherPageLink">
                                                        <img
                                                            src={process.env.PUBLIC_URL + "/assets/img/icon/user-circle.svg"}
                                                            alt="accountIcon"
                                                            className="IconTwoFive"
                                                        />
                                                        {t('editProfile')}
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                            <div className="ProfileOtherPageBox">
                                                <div className="ProfileOtherPageBoxcard">
                                                    <p htmlFor="notification" className="ProfileOtherPageText">
                                                        <img
                                                            src={process.env.PUBLIC_URL + "/assets/img/icon/notificationbell.svg"}
                                                            alt="notificationbell"
                                                            className="IconTwoFive"
                                                        />
                                                        {t('notiSettings')}
                                                    </p>
                                                    <div className="toggle-main" id="notification">
                                                        <label className={`switch ${userInfo?.is_notify ? 'active' : ''}`}>
                                                            <input
                                                                type="checkbox"
                                                                id="name"
                                                                checked={userInfo?.is_notify}
                                                                onChange={(e) => handleNotificationChange(e)}
                                                            />
                                                            <span className="slider round" />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                            <div className="ProfileOtherPageBox">
                                                <div className="ProfileOtherPageBoxcard">
                                                    <Link to="/animation-videos" className="ProfileOtherPageLink">
                                                        <img
                                                            src={process.env.PUBLIC_URL + "/assets/img/icon/animetionvideo.svg"}
                                                            alt="animetionvideo"
                                                            className="IconTwoFive"
                                                        />
                                                        {t('animationVideosHeading')}
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                            <div className="ProfileOtherPageBox">
                                                <div className="ProfileOtherPageBoxcard">
                                                    <a className="ProfileOtherPageLink">
                                                        <img
                                                            src={process.env.PUBLIC_URL + "/assets/img/icon/ChangepasswordIcon.svg"}
                                                            alt="ChangepasswordIcon"
                                                            className="IconTwoFive"
                                                        />
                                                        {userInfo ? userInfo?.user_language.native_name : ""}
                                                    </a>
                                                </div>
                                            </div>
                                        </div> */}
                                        {/* <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                            <div className="ProfileOtherPageBox">
                                                <div className="ProfileOtherPageBoxcard">
                                                    <a href="#" className="ProfileOtherPageLink">
                                                        <img
                                                            src={process.env.PUBLIC_URL + "/assets/img/icon/Choosecurrency.svg"}
                                                            alt="ChangepasswordIcon"
                                                            className="IconTwoFive"
                                                        />
                                                        {t('chooseCurrency')}
                                                    </a>
                                                </div>
                                            </div>
                                        </div> */}
                                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                            <div className="ProfileOtherPageBox">
                                                <div className="ProfileOtherPageBoxcard">
                                                    <a href='#' className="ProfileOtherPageLink"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            handleCopyLink();
                                                        }}
                                                    >
                                                        <img
                                                            src={process.env.PUBLIC_URL + "/assets/img/icon/ShareAppIcon.svg"}
                                                            alt="ShareAppIcon"
                                                            className="IconTwoFive"
                                                        />
                                                        {t('shareApp')}
                                                    </a>
                                                </div>
                                                {isModalOpen && (
                                                    <ShareAppModal
                                                        isOpen={isModalOpen}
                                                        isClose={() => setIsModalOpen(false)}
                                                        shareUrl={shareUrl}
                                                        title={title}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Profile